module.exports = __webpack_public_path__ + "img/dean.f0b547ab.jpeg";